import React, { useState, useRef } from "react";
import useClickOutside from "./useClickOutside";
import { buildPath } from "./useCategoryUtils";

const CategoryChip = ({
  chip,
  categoryMap,
  allCategories,
  onUpdate,
  onRemove,
}) => {
  const [open, setOpen] = useState(false);
  const [editDept, setEditDept] = useState(chip.path[0]?.slug || "");
  const [editCat, setEditCat] = useState(chip.path[1]?.slug || "");
  const [editSub, setEditSub] = useState(chip.path[2]?.slug || "");

  const ref = useRef(null);
  useClickOutside(ref, () => setOpen(false));

  const handleOpen = () => {
    setEditDept(chip.path[0]?.slug || "");
    setEditCat(chip.path[1]?.slug || "");
    setEditSub(chip.path[2]?.slug || "");
    setOpen(true);
  };

  const deptChildren =
    allCategories.find((c) => c.slug === editDept)?.children || [];
  const catChildren =
    deptChildren.find((c) => c.slug === editCat)?.children || [];

  const handleApply = () => {
    const path = buildPath([editDept, editCat, editSub], categoryMap);
    if (!path.length) return;

    onUpdate({
      slug: path[path.length - 1].slug,
      path,
    });

    setOpen(false);
  };

  const activeLabel = chip.path[chip.path.length - 1]?.label || "";

  const changed =
    editDept !== (chip.path[0]?.slug || "") ||
    editCat !== (chip.path[1]?.slug || "") ||
    editSub !== (chip.path[2]?.slug || "");

  return (
    <span className="selected-chip category" ref={ref}>
      <span className="chip-label" onClick={handleOpen}>
        {activeLabel}
        <span className="chip-arrow">{open ? "▲" : "▼"}</span>
      </span>

      <button
        className="chip-remove"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        ✕
      </button>

      {open && (
        <div className="chip-edit-popup">
          <div className="chip-edit-selects">
            <select
              value={editDept}
              onChange={(e) => {
                setEditDept(e.target.value);
                setEditCat("");
                setEditSub("");
              }}
            >
              <option value="">מחלקה</option>
              {allCategories.map((d) => (
                <option key={d.slug} value={d.slug}>
                  {d.name}
                </option>
              ))}
            </select>

            {editDept && deptChildren.length > 0 && (
              <select
                value={editCat}
                onChange={(e) => {
                  setEditCat(e.target.value);
                  setEditSub("");
                }}
              >
                <option value="">קטגוריה</option>
                {deptChildren.map((c) => (
                  <option key={c.slug} value={c.slug}>
                    {c.name}
                  </option>
                ))}
              </select>
            )}

            {editCat && catChildren.length > 0 && (
              <select
                value={editSub}
                onChange={(e) => setEditSub(e.target.value)}
              >
                <option value="">תת קטגוריה</option>
                {catChildren.map((c) => (
                  <option key={c.slug} value={c.slug}>
                    {c.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          {changed && (
            <button className="chip-apply-btn" onClick={handleApply}>
              עדכן
            </button>
          )}
        </div>
      )}
    </span>
  );
};

export default CategoryChip;
